/**
 * Injection tokens — §12.1, §12.2.
 *
 * §12.1's preferred path: `@bib/injector` supplies the service graph and
 * `@bib/solid_js_injector` the SolidJS bindings, so controllers are resolved
 * through a hierarchical scoped injector rather than a hand-rolled context.
 *
 * Controllers are factory functions returning `{ signals, derivations,
 * actions }` (§12.2). One token per controller; the providers are registered
 * once at the root in `App.tsx`.
 */

import { InjectionToken } from '@bib/injector';

import type { FeedController } from './feed-controller';
import type { SessionController } from './session-controller';
import type { ToastController } from './toast-controller';

export const SESSION = new InjectionToken<SessionController>('SessionController');
export const FEED = new InjectionToken<FeedController>('FeedController');
export const TOAST = new InjectionToken<ToastController>('ToastController');
